import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

// Bootstrap import
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

// debut feature
Vue.config.productionTip = false

// start vue
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
